import { useState, useEffect } from 'react';
import firebase from 'firebase/app';

export function useCustomer(customerId) {
  const [loading, setLoading] = useState(true);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    if (!customerId) {
      setCustomer(null);
      setLoading(false);
      return () => {};
    }
    setLoading(true);
    const db = firebase.firestore();
    const unsubscribe = db.collection('customers').doc(customerId).onSnapshot(
      (snap) => {
        setCustomer(snap.exists ? { id: snap.id, ...snap.data() } : null);
        setLoading(false);
      },
      (err) => {
        console.error('[useCustomer] Failed to load customer:', err);
        setCustomer(null);
        setLoading(false);
      }
    );
    return () => unsubscribe();
  }, [customerId]);

  return [loading, customer];
}
